import { render, staticRenderFns } from "./health-vault-recipient-verification.vue?vue&type=template&id=9bc726c4&scoped=true&"
import script from "./health-vault-recipient-verification.vue?vue&type=script&lang=js&"
export * from "./health-vault-recipient-verification.vue?vue&type=script&lang=js&"
import style0 from "./health-vault-recipient-verification.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./health-vault-recipient-verification.vue?vue&type=style&index=1&id=9bc726c4&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "9bc726c4",
  null
  
)

export default component.exports